import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Accordion, ContainedButton, HeaderTwo } from 'secondstep-components'
import AdminExportDownloadButton from 'components/AdminExportDownloadButton'
import InterventionsSubheader from 'components/admin/Interventions/Subheader'

const breakpoints = {
  customTablet: '@media screen and (max-width: 860px)',
}

export const Bullet = styled.span`
  display: inline-block;
  height: 0.8125rem;
  width: 0.8125rem;
  border-radius: 50%;
  background: ${themeGet('colors.yellow')};
  margin: 0 0.25rem;
`

export const ContentBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${themeGet('colors.white')};
  border-radius: 0.5rem;
`

export const CountCopy = styled.div`
  display: flex;
  align-items: center;
  font-family: ${themeGet('font.molde.medium')};
`

export const CountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  line-height: normal;
  color: ${themeGet('colors.darkGray')};
  gap: 0.5rem;
  flex: 1;
  padding-left: 2.25rem;

  ${Bullet} {
    margin: 0 0.375rem 0.125rem 0;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoints.customTablet} {
    flex-direction: column;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${breakpoints.customTablet} {
    flex-direction: column;
  }
`

export const LastUpdatedAtText = styled.span`
  position: relative;
  top: -0.6875rem;
  color: ${themeGet('colors.gray1100')};
  font-size: 0.75rem;

  ${breakpoints.customTablet} {
    display: none;
  }
`

export const LeftBox = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoints.customTablet} {
    margin-bottom: 0.4375rem;
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: 550px;

  svg {
    color: ${themeGet('colors.darkBlue')};
  }

  p {
    margin-top: 0.25rem;
    margin-left: 0.5rem;
    font-size: 1.125rem;
    font-family: ${themeGet('font.molde.medium')};
    color: ${themeGet('colors.darkGray')};
  }
`

export const NameWrapper = styled.span`
  font-family: ${themeGet('font.molde.medium')};
  color: ${themeGet('colors.darkBlue')};
  height: 100%;
  line-height: 1.3;
  flex: 1;
`

export const NotCompletedCopy = styled(CountCopy)`
  font-family: ${themeGet('font.molde.regular')};
`

export const PaginationButton = styled(ContainedButton)`
  :disabled {
    background: ${themeGet('colors.white')};
    color: ${themeGet('colors.darkGray')};
    border-color: ${themeGet('colors.buttons.primaryBackgroundDisabled')};
  }
`

export const PaginationIndexContainer = styled.div`
  color: ${themeGet('colors.darkGray')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1;
  gap: 0.625rem;
`

export const PaginationPageWrapper = styled.div`
  font-family: ${themeGet('font.molde.medium')};
`

export const PaginationSiteWrapper = styled.div``

export const PanelWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.375rem;

  ${breakpoints.customTablet} {
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 0.375rem;
  }
`

export const SiteCollapsible = styled(Accordion).attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  width: 100%;
  border: 2px solid
    ${themeGet('colors.backgrounds.secondary', 'colors.paleGray')};
  background: ${themeGet('colors.paleGray')};

  &:hover {
    outline: 2px solid ${themeGet('colors.grayBlue')};
  }

  svg {
    color: ${themeGet('colors.blue')};
    margin-right: 0;
  }

  [class*='AccordionPanel'] {
    padding: 1.25rem;
    background: ${themeGet('colors.paleGray')};
  }

  [class*='AccordionTitleWrapper'] {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  [class*='AccordionTitle'] {
    width: 100%;
  }

  [class*='AccordionContentWrapper'] {
    width: 100%;
    margin: 0;
    overflow: visible;
    [class*='AccordionContent'] {
      padding: 0 1.25rem 1.25rem 1.25rem;
      background: ${themeGet('colors.paleGray')};
    }
  }
`

export const SiteListContainer = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export const SiteListFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
`

export const SiteListHeader = styled.div.attrs(({ isScrolled }) => ({
  margin: isScrolled ? '0 1.25rem' : '0',
  padding: isScrolled
    ? '1.125rem 5.6875rem 0.9375rem 1.25rem'
    : '0 4.375rem 0.9375rem 0',
}))`
  display: flex;
  width: 100%;
  max-width: 1366px;
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  box-sizing: border-box;
`

export const StyledHeaderTwo = styled(HeaderTwo)`
  margin-bottom: 0.6875rem;
  line-height: 1;
`

export const StyledAdminExportDownloadButton = styled(
  AdminExportDownloadButton,
)`
  position: relative;
  top: -0.125rem;
  flex-shrink: 0;
`

export const StyledInterventionsSubheader = styled(InterventionsSubheader)`
  > div {
    margin: 0;
  }
`

export const StyledHr = styled.hr.attrs(({ isScrolled }) => ({
  margin: isScrolled ? '0.9375rem 0 3.3125rem' : '0.9375rem 0 1.125rem',
}))`
  width: 100%;
  border: 1px solid ${themeGet('colors.paleGray')};
  margin: ${({ margin }) => margin};
`

export const TierPill = styled.div`
  margin: 0 0 0.6875rem 1.125rem;

  span {
    background: ${themeGet('colors.aliceBlue')};
    color: ${themeGet('colors.darkGray')};
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    padding: 0.375rem 1rem 0.25rem;
    border-radius: 6.25rem;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Wrapper = styled.div`
  width: 100%;
  padding: 1.5625rem 1.25rem;
  box-sizing: border-box;
  border-radius: 0.625rem;
  background: ${themeGet('colors.backgrounds.primary', 'colors.white')};

  ${themeGet('breakpoints.mobileLarge')} {
    margin-bottom: 1.25rem;
  }
`
